module.exports = __webpack_public_path__ + "img/e-class-coupe.ffb5e153.jpg";